// Kart ve Banka Logo Mappingleri

// Kart Şeması Logoları (Visa, Mastercard, Troy)
export const CARD_SCHEME_LOGOS = {
  'visa': '/images/visa.png',
  'mastercard': '/images/master.png',
  'master': '/images/master.png',
  'troy': '/images/troy.png',
  'amex': '/images/amex.png', // Varsa
};

// Kart şemasını kart numarasından tespit et
export const detectCardScheme = (cardNumber) => {
  const cleanNumber = cardNumber?.replace(/\s/g, '') || '';
  if (!cleanNumber) return null;
  
  const firstDigit = cleanNumber[0];
  const firstTwo = cleanNumber.slice(0, 2);
  const firstFour = cleanNumber.slice(0, 4);
  
  // Visa: 4 ile başlar
  if (firstDigit === '4') return 'visa';
  
  // Mastercard: 51-55 veya 2221-2720
  if (['51', '52', '53', '54', '55'].includes(firstTwo)) return 'mastercard';
  const firstFourNum = parseInt(firstFour);
  if (firstFourNum >= 2221 && firstFourNum <= 2720) return 'mastercard';
  
  // Troy: 65 veya 9792
  if (firstTwo === '65' || firstFour === '9792') return 'troy';
  
  // Amex: 34 veya 37
  if (['34', '37'].includes(firstTwo)) return 'amex';
  
  return null;
};

// Banka Logo Mappingleri
// Banka adından logo dosyasını bul
export const BANK_LOGOS = {
  // Tam eşleşme
  'garanti': '/images/bonus.png', // Garanti = Bonus
  'garanti bbva': '/images/bonus.png',
  'garanti bankasi': '/images/bonus.png',
  'bonus': '/images/bonus.png',
  
  'yapı kredi': '/images/world.png',
  'yapi kredi': '/images/world.png',
  'yapikredi': '/images/world.png',
  'world': '/images/world.png',
  
  'akbank': '/images/axess.jpg',
  'axess': '/images/axess.jpg',
  
  'iş bankası': '/images/maximum.jpg',
  'is bankasi': '/images/maximum.jpg',
  'isbank': '/images/maximum.jpg',
  'türkiye iş bankası': '/images/maximum.jpg',
  'maximum': '/images/maximum.jpg',
  
  'halkbank': '/images/paraf.png',
  'halk bankası': '/images/paraf.png',
  'halk bankasi': '/images/paraf.png',
  'paraf': '/images/paraf.png',
  
  'vakıfbank': '/images/vakif.png',
  'vakifbank': '/images/vakif.png',
  'vakıf': '/images/vakif.png',
  'vakif': '/images/vakif.png',
  
  'ziraat': '/images/ziraat.png',
  'ziraat bankası': '/images/ziraat.png',
  'ziraat bankasi': '/images/ziraat.png',
  't.c. ziraat bankası': '/images/ziraat.png',
  
  'qnb': '/images/qnb.png',
  'qnb finansbank': '/images/qnb.png',
  'finansbank': '/images/qnb.png',
  'qnbfinansbank': '/images/qnb.png',
  
  'teb': '/images/teb.png',
  'türk ekonomi bankası': '/images/teb.png',
  'turk ekonomi bankasi': '/images/teb.png',
  
  'hsbc': '/images/hsbc.png',
  
  'albaraka': '/images/albaraka.svg',
  'albaraka türk': '/images/albaraka.svg',
  'albaraka turk': '/images/albaraka.svg',
  
  'yurtiçi': '/images/yurtici.jfif',
  'yurtici': '/images/yurtici.jfif',
  
  // Varsayılan (bulunamazsa)
  'default': null
};

// Banka adından logo URL'i bul
export const getBankLogo = (bankName) => {
  if (!bankName) return null;
  
  const normalizedName = bankName.toLowerCase().trim();
  
  // Tam eşleşme
  if (BANK_LOGOS[normalizedName]) {
    return BANK_LOGOS[normalizedName];
  }
  
  // Kısmi eşleşme
  for (const [key, logo] of Object.entries(BANK_LOGOS)) {
    if (normalizedName.includes(key) || key.includes(normalizedName)) {
      return logo;
    }
  }
  
  return null;
};

// Kart şeması logo URL'i bul
export const getCardSchemeLogo = (scheme) => {
  if (!scheme) return null;
  const normalizedScheme = scheme.toLowerCase().trim();
  return CARD_SCHEME_LOGOS[normalizedScheme] || null;
};

// Firma Bilgileri (yasal metinler için)
export const FIRMA_BILGILERI = {
  'OTOMOTIV': {
    unvan: 'YETSAN OTOMOTİV SAN. TİC. LTD. ŞTİ',
    adres: 'MACUN MAHALLESİ 209. SOKAK NO:15 YENİMAHALLE ANKARA',
    telefon: '+90 (312) 267 16 75',
    email: 'yetsanotomotiv@yetsan.com.tr',
    web: 'www.panel.otoradyator.com',
    mersis: '0953001500400018',
    vergi_dairesi: 'OSTİM VERGİ DAİRESİ',
    vergi_no: '9530015004'
  },
  'KONYA': {
    unvan: 'YETSAN KONYA OTOMOTİV SAN. TİC. LTD. ŞTİ',
    adres: 'FEVZİ ÇAKMAK MAH. 10594 SK. NO:28 KARATAY / KONYA',
    telefon: '+90 (332) 342 67 67',
    email: 'yetsankonya@yetsan.com.tr',
    web: 'www.panel.otoradyator.com',
    mersis: '0953001500400018', // Güncellenmeli
    vergi_dairesi: 'MERAM VERGİ DAİRESİ',
    vergi_no: '9530015004' // Güncellenmeli
  }
};
